var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hmi-label",style:({
  background: _vm.color,
  width: typeof _vm.width === 'number' ? _vm.width + 'px' : _vm.width,
  height: typeof _vm.height === 'number' ? _vm.height + 'px' : _vm.height,
  border: _vm.border,
}),on:{"click":_vm.handleClick}},[_c('v-label',{staticClass:"label"},[_vm._v(_vm._s(_vm.label))]),(_vm.active == '1')?_c('v-icon',{staticClass:"square",attrs:{"color":"red"}},[_vm._v("mdi-square")]):(_vm.active == '0')?_c('v-icon',{staticClass:"square",attrs:{"color":"transparent"}},[_vm._v("mdi-square")]):_vm._e(),_c('NumericKeypad',{ref:"keypad",on:{"input":_vm.emit}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }